/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const LayoutFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  Layout: gql`
    fragment LayoutQuery on layout_Entry {
      backgroundImage {
        url
        ... on images_Asset {
          altText
        }
      }
      productPickerTable {
        ... on productPickerCategories_Category {
          finderHeading
          productPickerCtaLabel
          stateDropdownLabel
          productDropdownLabel
          productPickerTable {
            state
            courseType
            productName
            productLink
            ctaOverride
            noReferrer
            noFollow
            modal
          }
        }
      }
      hideStandaloneProductPicker
      buttonAlignment
      buttonLayout
      buttons {
        buttonLabel
        buttonLink
        buttonLinkNewTab
        buttonLinkNofollow
        buttonType
        buttonCtaTag
      }
      dropdown {
        dropdownLabel
        dropdownLink
        dropdownLinkNewTab
        dropdownLinkNofollow
      }
      dropdownButtonType
      dropdownPlaceholder
      dropdownTopLabel
      highlightedTextModal1 {
        ... on highlightedTextModal12Block_Entry {
          modalContent {
            html
          }
        }
      }
      highlightedTextModal2 {
        ... on highlightedTextModal22Block_Entry {
          modalContent {
            html
          }
        }
      }
      image {
        url
        ... on images_Asset {
          altText
        }
      }
      imageAlignment
      imageVsContent
      layoutContent
      showTrustpilot
      layoutRightContent
      layoutSplit
      layoutTitle
      lineBreak_buttons
      lineBreak_dropdown
      lineBreak_mainContent
      lineBreak_modals
      lineBreak_styles
      styles
      typeHandle
    }
  `,
};
